/**
 * WordPress dependencies
 */
import { registerBlockStyle } from '@wordpress/blocks';

registerBlockStyle( 'core/image', [
	{
		name: 'default',
		label: 'Default',
		isDefault: true,
	},
] );
